export const myInjectionKey = Symbol('Symbol for Each Components')
